//Scroll to top
export default class ScrollButton {
  "use strict"

  constructor(options) {
    //this.button = document.getElementById(buttonID)
    this.button = this.criarBtn();

    if (this.button && options) {
      this.setPosition(options.position)
    } else {
      this.setPosition('left')
    }

    this.start()
  }

  /* Inicia o botao */
  start = function () {
    if (this.button) {
      this.button.addEventListener('click', function (e) {
        e.preventDefault()
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })

    } else {
      throw Error("Botão não definido!")
    }

    /* Oculta e exibe o botao de acordo com o scroll da página */
    document.addEventListener('scroll', () => { this.toggleButton() })
    document.addEventListener('load', () => { this.toggleButton() })

  }

  /* Define o posicionamento do botão | left, right, center */
  setPosition = function (position) {
      this.button.classList.add(`sc-${position}`)
  }

  /* Cria o botao */
  criarBtn = function () {

    //let parent = document.querySelector('footer');

    let btn = document.createElement('div')
    btn.setAttribute('id', 'scrolltop')
    btn.classList.add('scrolltop')

    document.body.appendChild(btn)

    return btn
  }

  /* Remove e adiciona a classe .show ao botao */
  toggleButton = function () {
    if (scrollY > 200) {
      this.button.classList.add('show')
    } else {
      this.button.classList.remove('show')
    }
  }

}

//const scrollbtn = new ScrollButton('scrolltop').start()


